"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchError = void 0;
var tslib_1 = require("tslib");
var FetchError = /** @class */ (function (_super) {
    tslib_1.__extends(FetchError, _super);
    function FetchError(message, data) {
        var _this = _super.call(this, message) || this;
        _this.data = data;
        _this.name = 'FetchError';
        return _this;
    }
    return FetchError;
}(Error));
exports.FetchError = FetchError;
//# sourceMappingURL=FetchError.js.map